module.exports = __webpack_public_path__ + "static/media/overlay-logo.a4685784.png";